import defaultClient from '@src/api/clients/default';

const URL = (path) => {
  return `dashboard/client-summary/${path}/`;
};

export function fetchClientSummaryByDate(payload = {}) {
  return defaultClient.request({
    url: URL('client-date'),
    payload,
  });
}

export function fetchVerticalSummary(payload = {}) {
  return defaultClient.request({
    url: URL('vertical'),
    payload,
  });
}

// Per-day totals across all matching clients, aggregated in SQL (includes
// fee_weighted_spend_sum). Powers the Company Performance chart + DoD table.
export function fetchClientSummaryDateRollup(payload = {}) {
  return defaultClient.request({
    url: URL('date-rollup'),
    payload,
  });
}

// Per-month totals across all matching clients, aggregated in SQL. Powers the
// Company Performance MoM table.
export function fetchClientSummaryMonthRollup(payload = {}) {
  return defaultClient.request({
    url: URL('month-rollup'),
    payload,
  });
}

export default {
  fetchClientSummaryByDate,
  fetchVerticalSummary,
  fetchClientSummaryDateRollup,
  fetchClientSummaryMonthRollup,
};
